import React, { useState } from 'react';
import { MigrateFinanceForm, MigrateHandForm } from './MigrateLoanForms';
import { BulkMigrateImport } from './BulkMigrateImport';

/** Migrate page body: one loan at a time, or many loans from an Excel sheet. */
export function MigratePanel({
  kind,
  canWrite,
  cutoverDefault,
  onDone,
}: {
  kind: 'finance' | 'handloan';
  canWrite: boolean;
  cutoverDefault: string;
  onDone: () => void;
}) {
  const [mode, setMode] = useState<'one' | 'bulk'>('one');
  const tab = (id: 'one' | 'bulk', label: string) => (
    <button
      type="button"
      onClick={() => setMode(id)}
      className={`rounded-lg px-3 py-1.5 text-sm font-semibold transition ${
        mode === id
          ? 'bg-emerald-600 text-white shadow-sm'
          : 'text-zinc-700 hover:bg-zinc-100 dark:text-zinc-200 dark:hover:bg-zinc-800'
      }`}
      aria-pressed={mode === id}
    >
      {label}
    </button>
  );
  return (
    <div className="space-y-4">
      <div className="inline-flex gap-1 rounded-xl border border-zinc-200 bg-white p-1 dark:border-zinc-700 dark:bg-zinc-900">
        {tab('one', 'One loan')}
        {tab('bulk', 'Import from Excel')}
      </div>
      {mode === 'bulk' ? (
        <BulkMigrateImport canWrite={canWrite} cutoverDefault={cutoverDefault} onDone={onDone} />
      ) : kind === 'finance' ? (
        <MigrateFinanceForm canWrite={canWrite} cutoverDefault={cutoverDefault} onDone={onDone} />
      ) : (
        <MigrateHandForm canWrite={canWrite} cutoverDefault={cutoverDefault} onDone={onDone} />
      )}
    </div>
  );
}
